module.exports = __webpack_public_path__ + "static/media/experience.2a3a7805.pdf";